import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getModel() {


                var form = {
                        id: null,
                        nome: "",
                        razaosocial: "",
                        cnpj: "",
                        data_cadastro: "",
                        fone: "",
                        celular: "",
                        email: "",
                        site: "",
                        contato: "",
                        ramo_atividade: "",
                        endereco: "",
                        cep: "",
                        bairro: "",
                        cidade: "",
                        estado: "",
                        obs: "",
                        logo: "",
                        tipo_prospecao: "",
                        tipo_cliente: "",
                        razao_social: "",
                        inscricao_estadual: "",
                        ccm: "",
                        fone2: "",
                        horario_funcionamento: "",
                        turnos: "",
                        status: "",
                        comentario_status: "",
                        text_area_atuacao: ""
                }

                return form;
        },

        getById(id) {

                return Api.Call("clientes/" + id, "get", {});

        },

        salvar(form, file_upload) {

                //fn_progress
                //clientes_uploadimagem

                let promise1 = new Promise((resolve, reject) => {

                        if (form.id != null && form.id != "") {
                                // var data = base.removeColumns( form, "cadastrado_por,valido,verificado,eliminado");
                                return Api.Call("clientes/" + form.id, "PUT", form).then(
                                        function (response) {
                                                if (file_upload != null && file_upload != undefined) {
                                                        Api.CallFormData("clientes_uploadimagem", "POST", { id: form.id, file: file_upload }).then(
                                                                function (response2) {
                                                                        return resolve(response);
                                                                }
                                                        )
                                                } else {

                                                        return resolve(response);
                                                }
                                        }
                                ).catch(function (error) {
                                        reject(error);
                                });
                        } else {


                                return Api.Call("clientes", "POST", form).then(
                                        function (response) {
                                                if (file_upload != null && file_upload != undefined) {
                                                        Api.CallFormData("clientes_uploadimagem", "POST", { id: response.data.item.id, file: file_upload }).then(
                                                                function (response2) {
                                                                        return resolve(response);
                                                                }
                                                        )
                                                } else {

                                                        return resolve(response);
                                                }
                                        }
                                ).catch(function (error) {
                                        reject(error);
                                });


                        }
                });

                return promise1;

        },
        delete(id) {
                return Api.Call("clientes/" + id, "DELETE", {});
        },
        filtrar(page, search) {

                var data = { filtro: search, page: page, pagesize: process.env.VUE_APP_PAGESIZE }

                return Api.Call("clientes_grid", "get", data);


        },

        getList(filtro, order, order_type) {

                var data = { filtro: filtro, order: order, order_type: order_type }

                return Api.Call("clientes?" + base.serialize(data), "get", data);


        },
        getList2(filtro, order, order_type) {

                var data = { filtro: filtro, order: order, order_type: order_type }

                return Api.Call("clientes2?" + base.serialize(data), "get", data);


        }


}
